import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { store } from '../stores/mainStore';
import { Button, ButtonBar } from './UI';
import { integration } from '../integration';

const config = window.dodConfig;

const HeartsZeroPage = styled.div`
	/* margin-top: 35%; */
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	padding-top: ${p => config.isLandscape ? 50 : 100}px;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: ${p => config.isLandscape ? 40 : 90}%;
	margin: 0 auto;
`

const BoxContent = styled.img`
	width: 90%;
	margin-top: 5%;
`


export class ModalPurchaseCancelled extends Component {
	
	constructor(props){
		super(props);
		integration.postAnalyticsEvent(`store_purchase_cancelled`, `economy`);
	}
	// continue(){
	// 	window.manager.playAudio("poopPop");
	// 	store.modal = '';
	// }

	// close() {
	// 	window.manager.playAudio("poopPop");
	// 	this.setState({iframe: ""});
	// }

	render() {
		return (
			<HeartsZeroPage>
				<Content>
					<CloseBox>
						{/* <CloseButton src="/assets/btn_close.png" onClick={e => this.continue()}/> */}
						<BoxContent src={`/assets/languages/${store.settings.language}/box_purchase_cancelled.png`}/>
						<ButtonBar>
							<Button purchase_cancelled
								onClick={() => {
                                    window.manager.playAudio("poopPop");
                                    store.modal = '';
									integration.postAnalyticsEvent(`store_purchase_cancel_ok`, `economy`);
								}}
							/>
						</ButtonBar>
					</CloseBox>
				</Content>
			</HeartsZeroPage>
		)
	}
}
